import React from "react";
import cn from "classnames";
import "./style.scss";

export const GLOBAL_PAGE_LOADER_ID = "global-page-loader";

export const LoaderPage = ({ show = true, global = false } = {}) => {
  return (
    <div
      id={global ? GLOBAL_PAGE_LOADER_ID : undefined}
      className={cn("loader-page-all-requests", {
        "loader-page-all-requests_show": show,
      })}
    >
      <div className="spinner-box">
        <div className="circle-border">
          <div className="circle-core"></div>
        </div>
      </div>
    </div>
  );
};
